import { useIsAuthenticated } from "@azure/msal-react";
import { RootState } from "core-integration/src/store";
import {
  getLoginError,
  getPlayerData,
} from "core-integration/src/store/player/reducers";
import { login } from "core-integration/src/store/player/thunks";
import { ILoginData } from "core-integration/src/store/player/types";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";

import { SignInButton } from "../utils/SignInButton";

const Promo = styled.div`
  margin: ${({ theme }) =>
    `${theme.space[4]} ${theme.space[4]} ${theme.space[6]}`};
  padding: ${({ theme }) => theme.space[3]};
  border-radius: ${({ theme }) => theme.radii[2]};
  background: ${({ theme }) => theme.colors.secondaryTwo};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 3rem;
    text-align: start;
  }
`;

const PromoLeft = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex: 0 0 calc(70% - 1rem);
    padding-inline-end: ${({ theme }) => theme.space[4]};
  }
`;

const PromoRight = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex: 0 0 calc(30% - 1rem);
    align-self: center;
    > a {
      text-transform: capitalize;
    }
  }
`;

const PromoHeading = styled.h3`
  margin: 0;
  font-size: 2.1rem;
  font-family: ${({ theme }) => theme.fonts.base};
  color: ${({ theme }) => theme.colors.primary};
`;

const PromoText = styled.p`
  margin-bottom: ${({ theme }) => theme.space[4]};
  color: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-bottom: 0;
  }
`;

const LoggedInStatus = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => `${theme.space[2]} ${theme.space[6]} 1.2rem`};
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.secondary};
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[5]};
  font-weight: normal;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`;

const mapState = (state: RootState) => ({
  error: getLoginError(state),
  player: getPlayerData(state),
});

const mapDispatch = {
  login: (data: ILoginData) => login(data),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Login: React.FC<PropsFromRedux> = ({ player }) => {
  const { t } = useTranslation();
  // TODO - Probably should send user to correct page after login
  const isAuthenticated = useIsAuthenticated();

  if (player && player.id) {
    return (
      <LoggedInStatus>
        {t(
          "login.loggedInAs",
          "Welcome to the Liga Portugal Betclic Fantasy {{firstName}} {{lastName}}",
          {
            firstName: player.first_name,
            lastName: player.last_name,
          },
        )}
      </LoggedInStatus>
    );
  }

  return (
    <>
      <Promo>
        <PromoLeft>
          <PromoHeading>
            {t("login.promo.heading", "Play Fantasy Liga Portugal Betclic")}
          </PromoHeading>
          <PromoText>
            {t(
              "login.promo.paragraph",
              "Challenge your friends in Fantasy Liga Portugal and have the chance to win both bragging rights and great prizes every round!",
            )}
          </PromoText>
        </PromoLeft>
        <PromoRight>
          {/* <Button width={1} as={Link} to="/" variant="primary">
            {t("login.promo.signUpNow", "Sign Up Now")}
          </Button> */}
          {isAuthenticated ? (
            t("loginText", "Signing you in ..")
          ) : (
            <SignInButton />
          )}
        </PromoRight>
      </Promo>
    </>
  );
};

export default connector(Login);
